import React from "react";

const WBOMoneySwipeTrans = () => {
  return <div>WBOMoneySwipeTrans WBOMoneySwipeTrans</div>;
};

export default WBOMoneySwipeTrans;
